


















































































































































































import { Component } from 'vue-mixin-decorator';

import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import RepositoryFactory from '@/repository/RepositoryFactory';

import MarkdownToHTML from '@/common/MarkdownToHTML';
import * as StringUtil from '@/common/StringUtil';

import * as DesignCode from '@/classification/DesignCode';

import News from '@/models/exam/News';
import Rank from '@/models/rank/Rank';
import Entry from '@/models/entry/Entry';
import DesignResource from '@/models/exam/DesignResource';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class MyPage extends BaseView {
  private isIndicatorDisplay = false;

  private examTitle = '';

  private news: News[] = [];

  private notTakenExam: Entry[] = [];

  private takenExam: Entry[] = [];

  private recommendExam: Rank[] = [];

  private ExamRepository = RepositoryFactory.get().exam;

  private EntryRepository = RepositoryFactory.get().entry;

  private GoodsRepository = RepositoryFactory.get().goods;

  private RankRepository = RepositoryFactory.get().rank;

  private MyPageRepository = RepositoryFactory.get().mypage;

  private resources = {
    NEWS_ICON: new DesignResource(),
    NEWS_ROW_HEAD_ICON: new DesignResource(),
    NEWS_MAIN_COLOR: new DesignResource(),
    NEWS_SUB_TITLE_COLOR: new DesignResource(),
    EXAM_RANK_ICON: new DesignResource(),
    GOODS_APPEAL_IMG: new DesignResource(),
  };

  private async mounted() {
    this.isIndicatorDisplay = true;

    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const MypageCss = document.createElement('link');
    MypageCss.rel = 'stylesheet';
    MypageCss.href = '/account/css/mypage.css';
    this.$el.appendChild(MypageCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    try {
      await this.forceExamEnd();
      await this.getMyPageInfo();
      await this.getExamInfo();
      await this.getEntry();
      await this.getRecommend();
    } catch (e) {
      this.$router.replace(this.paths.LOGIN);
    } finally {
      this.isIndicatorDisplay = false;
    }

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * 受験中ステータスとなっている受験データの強制終了
   */
  private async forceExamEnd() {
    await this.EntryRepository.putForceExamEnd();
  }

  /**
   * マイページ情報取得
   */
  private async getMyPageInfo() {
    await this.MyPageRepository.getMyPageInfo().then((response) => {
      if (response.status === 200 && response.data.news !== undefined) {
        response.data.news.forEach((news: any) => {
          const newsObj = new News();
          newsObj.date = news.date;
          newsObj.text = MarkdownToHTML(news.text);
          this.news.push(newsObj);
        });
      }
    });
  }

  /**
   * 検定情報の取得
   */
  private getExamInfo() {
    // 検定情報APIを呼び出し、お知らせを生成
    this.ExamRepository.getExam().then((response) => {
      if (response.status === 200) {
        this.examTitle = response.data.exam_title;

        // デザインリソース
        if (response.data.resources !== undefined) {
          response.data.resources.forEach((resource: any) => {
            const key = resource.display_place_key;
            if (key in this.resources) {
              const tmp = new DesignResource();
              tmp.displayPlaceKey = resource.display_place_key;
              tmp.displayText = StringUtil.isEmpty(resource.display_text) ? '' : resource.display_text;
              tmp.cssClassName = StringUtil.isEmpty(resource.css_class_name) ? '' : resource.css_class_name;
              tmp.resourceUri = StringUtil.isEmpty(resource.resource_uri) ? '' : resource.resource_uri;
              tmp.resourceFileName = StringUtil.isEmpty(resource.resource_file_name) ? '' : resource.resource_file_name;
              tmp.alternativeText = StringUtil.isEmpty(resource.alternative_text) ? '' : resource.alternative_text;
              // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
              // @ts-ignore
              this.resources[key] = tmp;
            }
          });
        }
      }
    });
  }

  /**
   * 申し込み済みの検定情報の取得
   */
  private getEntry() {
    // 未受験（申し込み済み）の試験および受験済みの試験の生成
    this.EntryRepository.getEntry().then((response) => {
      if (response.status === 200 && response.data.entries !== undefined) {
        response.data.entries.forEach((entry: any) => {
          if (entry.is_canceled) return;

          const entryObj = new Entry();
          entryObj.entryCode = entry.examination_entry_code;
          // 遷移時にBase64エンコードの文字列を求められるのでエンコード
          entryObj.rankCode = StringUtil.encodeToBase64Url(entry.exam_rank.exam_rank_code);
          entryObj.entryDate = StringUtil.toJapanDateString(entry.entry_datetime, 'YYYY/MM/DD');
          entryObj.title = entry.exam_rank.exam_rank_title;
          entryObj.registrationRequired = entry.exam_rank.registration_required;

          entry.exam_rank.resources.forEach((resource: any) => {
            if (resource.display_place_key === DesignCode.EXAM_RANK_ICON) {
              entryObj.thumbnail = resource.resource_uri;
              entryObj.alternativeText = resource.alternative_text;
            }
          });

          if (entry.results.length > 0) {
            // 受験済みの試験
            entry.results.forEach((result: any) => {
              const entryObjCopy = Entry.clone(entryObj);
              // eslint-disable-next-line @typescript-eslint/camelcase, object-curly-newline
              const { examination_result_code, status, can_retake, examination_datetime } = result;
              entryObjCopy.status = status;
              entryObjCopy.resultDate = StringUtil.toJapanDateString(examination_datetime, 'YYYY/MM/DD');

              if (entry.exam_rank.is_goods) {
                // 物販 は無視
              } else if (status === 'taking') {
                // 受験中の場合、未受験扱いにする
                this.notTakenExam.push(entryObjCopy);
              } else {
                // eslint-disable-next-line @typescript-eslint/camelcase
                entryObjCopy.resultCode = examination_result_code;

                // eslint-disable-next-line @typescript-eslint/camelcase
                entryObjCopy.canRetake = can_retake;
                this.takenExam.push(entryObjCopy);
              }
            });
          } else {
            if (entry.exam_rank.is_goods) return;
            // 未受験の試験
            this.notTakenExam.push(entryObj);
          }
        });
      }
    });
  }

  /**
   * おすすめ検定情報の取得
   */
  private async getRecommend() {
    await this.RankRepository.getRanks().then((response) => {
      if (response.status === 200 && response.data.exam_ranks !== undefined) {
        response.data.exam_ranks.forEach((rank: any) => {
          if (rank.is_recommend) {
            const rankObj = new Rank();

            // 遷移時にBase64エンコードの文字列を求められるのでエンコード
            rankObj.rankCode = StringUtil.encodeToBase64Url(rank.exam_rank_code);
            rankObj.title = rank.exam_rank_title;

            // サムネイルを作成する
            rank.resources.forEach((resource: any) => {
              if (resource.display_place_key === DesignCode.EXAM_RANK_ICON) {
                rankObj.thumbnail = resource.resource_uri;
                rankObj.alternativeText = resource.alternative_text;
              }
            });
            this.recommendExam.push(rankObj);
          }
        });
      }
    });
  }

  /**
   * 検定開始に遷移します。
   *
   * @param ランクコード（Base64エンコードされたコード）
   * @param 受験申込コード
   */
  private transitionExamReady(rankCode: string, entryCode: string) {
    // eslint-disable-next-line @typescript-eslint/camelcase
    this.$router.replace({ path: this.paths.EXAM_READY, query: { rank: rankCode, examination_entry_code: entryCode, is_callback: '0' } });
  }

  /**
   * 検定結果に遷移します。
   *
   * @param 受験申込コード
   * @param 受験結果コード
   * @param アカウント登録必要フラグ
   */
  private transitionExamResult(entryCode: string, resultCode: string, registrationRequired: boolean) {
    if (registrationRequired) {
      this.$router.replace(`${this.paths.EXAM_RESULT}?entry=${entryCode}&result=${resultCode}`);
    } else {
      this.$router.replace(`${this.paths.GUEST_EXAM_RESULT}?entry=${entryCode}&result=${resultCode}`);
    }
  }

  /**
   * 検定詳細画面に遷移します。
   *
   * @param ランクコード（Base64エンコードされたコード）
   */
  private transitionExamDetail(rankCode: string) {
    this.$router.replace(`${this.paths.KENTEI_DETAIL}?rank=${rankCode}`);
  }
}
